import * as angular from "angular";
import {SidebarController} from "./sidebar.controller";
const templateUrl = require("./sidebar.html");

export const sidebar: angular.IDirective = {
    templateUrl: templateUrl,
    controller: SidebarController,
    controllerAs: "vm",
    bindToController: true,
    scope: {}
};


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/sidebar/sidebar.ts
 **/